"use client";

import { FadeIn, FadeInStaggerItem, Stagger } from "@/components/ui/motion";
import { Coffee, Cpu, Rocket, Users } from "lucide-react";

export function WhyJoinUs() {
    const perks = [
        {
            icon: Cpu,
            title: "Elite Tech Stack",
            desc: "Work on the frontier of Gen AI, Agentic AI, and high-performance cloud architectures. We never settle for legacy.",
            color: "text-blue-600",
            bg: "bg-blue-50"
        },
        {
            icon: Rocket,
            title: "Exponential Growth",
            desc: "Join an elite group of senior engineers. We prioritize mentorship and fast-tracked leadership opportunities.",
            color: "text-purple-600",
            bg: "bg-purple-50"
        },
        {
            icon: Users,
            title: "Engineering First",
            desc: "Founded by engineers, for engineers. We value deep work, clean code, and solving complex problems from first principles.",
            color: "text-emerald-600",
            bg: "bg-emerald-50"
        },
        {
            icon: Coffee,
            title: "Work with Freedom",
            desc: "Remote-first culture with absolute flexibility. We care about impact and outcomes, not hours spent in a desk.",
            color: "text-amber-600",
            bg: "bg-amber-50"
        }
    ];

    return (
        <section className="py-24 bg-gray-50/50 border-y border-gray-100 relative overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <FadeIn>
                    <div className="text-center max-w-2xl mx-auto mb-16">
                        <h2 className="text-4xl font-bold mb-6 tracking-tight uppercase">Why Join Us?</h2>
                        <p className="text-lg text-gray-500">
                            Build the future of <span className="text-black font-bold">AI Engineering</span> while building the career you've always wanted.
                        </p>
                    </div>
                </FadeIn>

                <Stagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {perks.map((perk, i) => (
                        <FadeInStaggerItem key={i} className="h-full">
                            <div className="h-full bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl hover:border-black/5 transition-all duration-300 group flex flex-col">
                                <div className={`w-14 h-14 rounded-xl ${perk.bg} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                                    <perk.icon className={`h-7 w-7 ${perk.color}`} />
                                </div>
                                <h3 className="text-xl font-bold mb-3 text-gray-900 uppercase tracking-tight">{perk.title}</h3>
                                <p className="text-gray-500 text-sm leading-relaxed">{perk.desc}</p>
                            </div>
                        </FadeInStaggerItem>
                    ))}
                </Stagger>
            </div>
        </section>
    );
}
